<form [formGroup]="checklistForm" (ngSubmit)="onSubmit()">
    <div class="checklist-meta-info form-controls">
        <input
            hamInput
            class="checklist-input"
            label="{{ 'aumico_reports_checklist_title_label' | i18next }}"
            placeholder="{{ 'aumico_reports_checklist_title_placeholder' | i18next }}"
            [formControl]="checklistForm.get('name')"
            *ngIf="allowEditTitle"
        />

        <input
            hamSearchDropDown
            *ngIf="hasFlis && flis?.length"
            label="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
            formControlName="flis"
            placeholder="{{ 'aumico_annual_report_special_flis_please_select' | i18next }}"
            [options]="flis"
            [optionKeys]="['name']"
            [returnKey]="'id'"
            [multiple]="true"
        />
    </div>

    <div formArrayName="tasks" class="tasks-list">
        <label class="form-title">{{ 'aumico_reports_fcp_edit_checklist' | i18next }} </label>
        <div *ngFor="let task of tasks.controls; let i = index" [formGroupName]="i" class="task-item">
            <input
                hamInput
                class="checklist-input"
                [formControl]="tasks.controls[i]"
                placeholder="{{ 'aumico_reports_enter_task_placeholder' | i18next }}"
            />

            <span
                hamIconShapes
                icon="assets/hamIcons/minus.svg"
                [variant]="'hamed'"
                [size]="'xs'"
                [type]="'circle'"
                (click)="removeTask(i)"
            ></span>
        </div>
        <div class="error" *ngIf="tasks.errors?.['duplicateText']">
            {{ 'aumico_annual_report_fcp_checklist_not_allow_duplicate' | i18next }}
        </div>
    </div>
    <ham-button
        class="add-tasks-btn"
        outline="true"
        [size]="'xs'"
        icon="assets/hamIcons/plus-outline.svg"
        (buttonClick)="addTask()"
        >{{ 'aumico_reports_add_more_tasks_button' | i18next }}</ham-button
    >

    <div class="button-group">
        <ham-button outline="true" (buttonClick)="onCancel()">{{
            'aumico_reports_cancel_button' | i18next
        }}</ham-button>
        <ham-button (buttonClick)="onSubmit()" type="submit" [disabled]="checklistForm.invalid || tasks.length < 1">{{
            'aumico_reports_save_checklist_button' | i18next
        }}</ham-button>
    </div>
</form>
